import clsx from 'clsx';
import { navigate } from 'gatsby-link';
import { Search } from 'lucide-react';
import React from 'react';
import { useScreenResizer } from '../../../../contexts/screen-resize-context';
import { sendTrackingData } from '../../../../utils';
import { Button } from '../../../atoms/button';
import { CallUs } from '../../../atoms/call-us';
import { TextInput } from '../../../atoms/text-input';

// eslint-disable-next-line react/prop-types
function StickySearchBar({ mobileOnlyHamburger }) {
	const [searchValue, setSearchValue] = React.useState('');
	const searchRef = React.useRef(null);

	const handleSearch = () => {
		if (searchValue.trim()) {
			navigate(
				`/elearning/search-results?query=${encodeURIComponent(
					searchValue.trim()
				)}`
			);
		}
	};
	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			handleSearch(); // Trigger search on Enter key press
		}
	};
	const handleClickTracking = (trackData) => {
		const gtmStartedEvent = window.dataLayer?.find(
			(element) => element['gtm.start']
		);
		if (!gtmStartedEvent) return;

		sendTrackingData('click', trackData);
	};
	const { width } = useScreenResizer();
	const callUsMobileWidth = 1024;
	const callUsMobile = width > callUsMobileWidth;
	return (
		<form className="flex bg-white w-full items-center justify-between py-0 transform  transition-all duration-300 ease-in-out">
			<div className="relative flex-1">
				<TextInput
					id="search"
					name="search"
					ref={searchRef}
					onClick={handleSearch}
					aria-required="true"
					placeholder="Search courses..."
					onKeyDown={handleKeyDown}
					onChange={(e) => {
						setSearchValue(e.target.value);
						// setShowResults(false);
					}}
					value={searchValue}
					type="text"
					className="w-full wrapper-small [&>input]:pl-[57px] lg:[&>input]:pl-[60px] !mb-0"
				/>
				<Button
					type="button"
					aria-label="Search"
					onClick={handleSearch}
					variant="Unset"
					className={clsx(
						' absolute top-4 left-0',
						'bg-brand-blue-400  p-[15px] rounded-sm'
					)}
				>
					<Search className="w-5 h-5 text-white text-xs" />
				</Button>
			</div>
			{callUsMobile && (
				<div className="flex-1 flex justify-end">
					<CallUs
						callFrom="page"
						className={`text-right ${
							!mobileOnlyHamburger ? '' : 'lg:border-none'
						} border-r border-brand-pale-500 focus:outline-0 focus:shadow-focus focus:rounded-xs`}
						onClickProp={() =>
							handleClickTracking({
								event_name: 'navigation',
								click_type: 'tel',
							})
						}
					/>
				</div>
			)}
		</form>
	);
}

export default StickySearchBar;
